import { useNavigate, useLocation } from 'react-router-dom';

export function useBackRoute(defaultFallback = '/') {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = () => {
    const from = location.state?.from;
    if (from && typeof from === 'string' && from.startsWith('/') && from !== location.pathname) {
      navigate(from);
      return;
    }
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(defaultFallback);
    }
  };

  return goBack;
}
